module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    key: _vm.cnprosKey,
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.cnpros), function(cp) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }, [_c('a', {
      staticStyle: {
        "color": "#000",
        "cursor": "pointer"
      },
      attrs: {
        "href": 'cnpro?context=' + cp.cnpro_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "border": "solid 1px rgb(209, 205, 205)",
        "background": "#fff",
        "min-height": "25em",
        "max-height": "25em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "bg_image",
      style: ({
        'background': 'url(' + _vm.img_cp_url + cp.cnpro_bg_image + ')',
        backgroundSize: _vm.backgroundSize
      })
    }, [_c('div', {}, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-left": "auto",
        "margin-right": "auto",
        "border": "1px solid rgba(255, 255, 255, 0.6)",
        "margin": "0 auto",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v(_vm._s(cp.cnpro_category))]), _vm._v(" |\r\n                                                          "), _c('span', [_vm._v(_vm._s(cp.cnpro_jobs_done) + " Job(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticStyle: {
        "margin-top": "1em",
        "font-size": "1em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewCnpro(cp)
        }
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])]), _vm._v(" "), _c('div', {
      staticClass: "descr"
    }, [_c('p', {
      staticClass: "truncate-words"
    }, [_vm._v(_vm._s(cp.cnpro_description))])]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(cp.cnpro_rating_average_rate) + " Point(s)\r\n                                                           " + _vm._s(cp.cnpro_reviews_total_count) + " Review(s)\r\n                                                    ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.cnpros_store.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count, 'cnpros')
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sortCnpros(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "otherwrap"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.other_cnpros), function(cp) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }, [_c('a', {
      staticStyle: {
        "color": "#000",
        "cursor": "pointer"
      },
      attrs: {
        "href": 'cnpro?context=' + cp.cnpro_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "border": "solid 1px rgb(209, 205, 205)",
        "background": "#fff",
        "min-height": "25em",
        "max-height": "25em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "bg_image",
      style: ({
        'background': 'url(' + _vm.img_cp_url + cp.cnpro_bg_image + ')',
        backgroundSize: _vm.backgroundSize
      })
    }, [_c('div', {}, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-left": "auto",
        "margin-right": "auto",
        "border": "1px solid rgba(255, 255, 255, 0.6)",
        "margin": "0 auto",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v(_vm._s(cp.cnpro_category))]), _vm._v(" |\r\n                                                          "), _c('span', [_vm._v(_vm._s(cp.cnpro_jobs_done) + " Job(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticStyle: {
        "margin-top": "1em",
        "font-size": "1em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewCnpro(cp)
        }
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])]), _vm._v(" "), _c('div', {
      staticClass: "descr"
    }, [_c('p', {
      staticClass: "truncate-words"
    }, [_vm._v(_vm._s(cp.cnpro_description))])]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(cp.cnpro_rating_average_rate) + " Point(s)\r\n                                                           " + _vm._s(cp.cnpro_reviews_total_count) + " Review(s)\r\n                                                    ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.other_cnpros_store.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count, 'othercnpros')
      },
      model: {
        value: (_vm.other_cnpros_current_page),
        callback: function($$v) {
          _vm.other_cnpros_current_page = $$v
        },
        expression: "other_cnpros_current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sortOtherCnpros(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])], 2)])], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("Other CNpros ")]), _vm._v(" in Abuja")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b3455d4"}!./src/components/CnproSearch/template.html
// module id = 289
// module chunks = 0